import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Field } from '@itds/elements/index.js';
import {
  GUARANTEED_UNIVERSAL_LIFE_PRODUCTS,
  OTHER_PRODUCTS,
  ROP_PRODUCTS,
  TERM_LIFE_INSURANCE_PRODUCTS
} from '@itds/Constants';

const LimitProductTypes = ({ website_quoter, updateWebsiteQuoter }) => {
  const all_product_types = [
    ...TERM_LIFE_INSURANCE_PRODUCTS,
    ...GUARANTEED_UNIVERSAL_LIFE_PRODUCTS,
    ...ROP_PRODUCTS,
    ...OTHER_PRODUCTS
  ];

  const [data, setData] = useState({
    product_types: website_quoter.product_types.length
      ? website_quoter.product_types
      : all_product_types
  });

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const save = () => {
    updateWebsiteQuoter(data);
  };

  const selectAll = () => {
    if (data.product_types.length === all_product_types.length) {
      setData({
        ...data,
        product_types: []
      });
    } else {
      setData({
        ...data,
        product_types: all_product_types
      });
    }
  };

  return (
    <>
      <div style={{ display: 'flex', marginBottom: 30 }}>
        <Button inline={true} onClick={selectAll} small={true}>
          {data.product_types.length === all_product_types.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      <div style={{ display: 'flex', marginBottom: 30 }}>
        <div style={{ width: '25%' }}>
          <Field label='Term Life'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={TERM_LIFE_INSURANCE_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Guaranteed Universal Life'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={GUARANTEED_UNIVERSAL_LIFE_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Return of Premium'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={ROP_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Other'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={OTHER_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>
      </div>

      <Button disabled={!data.product_types.length} inline={true} onClick={save}>
        Save Changes
      </Button>
    </>
  );
};

LimitProductTypes.propTypes = {
  updateWebsiteQuoter: PropTypes.func,
  website_quoter: PropTypes.object
};

export default LimitProductTypes;
